module.exports = __webpack_public_path__ + "static/new-background.6674e610.JPG";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/2022/photos/accueil/nouveau/new-background.JPG
// module id = 535
// module chunks = 1 2 3 4